import { Stack, Typography } from '@prenuvo/halo';

import { api } from '@/api';
import { useStudyGuard } from '@/shared/guard';
import { Loading } from '@/shared/ui';

import { PatientDocument } from '../patient-docs-side-panel.model';
import { PatientDocsProvider } from './patient-docs.provider';
import { PatientDocsView } from './patient-docs-view.component';

interface PatientDocsProps {
  onUpdateSidePanelPatientDoc: (value: PatientDocument) => void;
  patientDocument?: PatientDocument;
}

export function PatientDocs({ onUpdateSidePanelPatientDoc, patientDocument }: PatientDocsProps) {
  const {
    radiologistScan: { patientID },
  } = useStudyGuard();

  const {
    data: docs,
    isError: isDocsError,
    isFetching: isFetchingDocuments,
  } = api.fct.documents.query.useGetActiveDocuments({
    payload: { params: { patient_id: patientID } },
  });

  const {
    data: types,
    isError: isTypesError,
    isFetching: isFetchingTypes,
  } = api.fct.documentTypes.query.useGetDocumentTypes();

  if (isFetchingDocuments || isFetchingTypes) {
    return <Loading className="h-[calc(100vh-128px)]" />;
  }

  if (isDocsError || !docs) {
    return (
      <Stack alignment="center" className="h-[calc(100vh-128px)]" justification="center">
        <Typography translationKey="FCT.PATIENT_DOCS.SIDE_PANEL.DOCUMENTS.ERROR" />
      </Stack>
    );
  }

  if (isTypesError || !types) {
    return (
      <Stack alignment="center" className="h-[calc(100vh-128px)]" justification="center">
        <Typography translationKey="FCT.PATIENT_DOCS.SIDE_PANEL.DOCUMENT_TYPES.ERROR" />
      </Stack>
    );
  }

  return (
    <Stack
      className="custom-scrollbar mx-auto max-h-[calc(100vh-128px)] w-full overflow-auto px-2"
      variant="vertical"
    >
      <PatientDocsProvider
        documents={docs}
        onUpdateSidePanelPatientDoc={onUpdateSidePanelPatientDoc}
        patientDocument={patientDocument}
        types={types}
      >
        <PatientDocsView />
      </PatientDocsProvider>
    </Stack>
  );
}
